import { render, staticRenderFns } from "./Carts.vue?vue&type=template&id=67fb096a&scoped=true"
import script from "./Carts.vue?vue&type=script&lang=js"
export * from "./Carts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fb096a",
  null
  
)

export default component.exports